"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:5.1.3'] && _();
}
catch (e) { }
